export default __webpack_public_path__ + "static/media/logo1.97010417.png";